import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

// SEO Configuration: Map of routes to their SEO metadata
// Based on client-provided Section 3 Meta Titles & Descriptions
// Location Keywords from Section 4: Hyderabad, Secunderabad, Kompally, Suchitra, Alwal, Bolarum, Medchal, Bowenpally, Fox Sagar Lake, Jeedimetla, Quthbullapur
const seoConfig = {
    // Home Page
    '/': {
        title: 'Sherwood Public School - Nursery, LKG, UKG, & ICSE School in Kompally, Secunderabad',
        description: 'Admissions open for Nursery, LKG & UKG at Sherwood Public School Kompally. Safe campus, activity-based early learning and strong ICSE academic foundation.',
        keywords: 'Pre School in Kompally, ICSE School Kompally, ICSE School Secunderabad, Nursery Admissions Kompally, LKG Admissions 6, UKG Admissions 2026, ICSE schools in Secunderabad, Activity-based education'
    },
    // About Page (Our Journey)
    '/our-journey': {
        title: 'About Sherwood Public School – Early Years & ICSE Education',
        description: 'Learn about Sherwood Public School\'s philosophy of early childhood learning and academic excellence through the ICSE curriculum.',
        keywords: 'About Sherwood Public School, ICSE education Hyderabad, Early childhood education Kompally, Schools near Alwal, Schools near Bolarum, Experienced faculty Secunderabad'
    },
    // Campus Life Page (Campus and Facilities)
    '/campus-and-facilities': {
        title: 'Facilities – Sherwood Public School | Smart Classrooms & Safe Campus',
        description: 'Sherwood Public School offers smart classrooms, labs, libraries, sports facilities, and a child-safe campus near Kompally & Jeedimetla.',
        keywords: 'School facilities Kompally, Smart classrooms Hyderabad, Safe campus Secunderabad, Schools near Fox Sagar Lake, Labs and libraries ICSE school'
    },
    // Leadership
    '/leadership': {
        title: 'Leadership Team | Sherwood Public School Hyderabad',
        description: 'Meet the dedicated leadership team at Sherwood Public School - shaping young minds with experienced faculty at our ICSE school near Kompally, Secunderabad.',
        keywords: 'School leadership Hyderabad, ICSE school management, Experienced faculty Secunderabad, Schools near Medchal'
    },
    // Philosophy
    '/philosophy': {
        title: 'Our Philosophy | Sherwood Public School – Holistic ICSE Education',
        description: 'Our educational philosophy at Sherwood Public School focuses on holistic development. ICSE curriculum with innovative methodologies near Kompally, Secunderabad.',
        keywords: 'Education philosophy Hyderabad, ICSE curriculum approach, Holistic development Secunderabad, Schools near Bowenpally'
    },
    // Pre School
    '/pre-school': {
        title: 'Pre Primary School in Kompally – Nursery, LKG & UKG Admissions | Sherwood Public School',
        description: 'Looking for a Pre School in Kompally? Sherwood Public School offers Nursery, LKG and UKG programs with activity-based learning and a safe campus environment.',
        keywords: 'Pre School in Kompally, Nursery Admissions Kompally, LKG Admissions 2026, UKG Admissions 2026, Nursery School Kompally, Pre School Hyderabad, Early childhood education, Activity-based learning, Schools near Alwal'
    },
    // Play School
    '/play': {
        title: 'Outdoor Learning Center \– Sherwood Public School',
        description: 'Experience hands-on education through Sherwood Public School\'s Outdoor Learning Center for experiential, nature-based learning.',
        keywords: 'Play school Kompally, Play school Hyderabad, Early learning Secunderabad, Schools near Alwal, Schools near Suchitra'
    },
    // Academics/ICSE Page
    '/icse': {
        title: 'ICSE Curriculum – Primary to Grade X | Sherwood Public School',
        description: 'Explore Sherwood Public School\’s ICSE curriculum designed to build strong academic foundations and holistic development.',
        keywords: 'ICSE School Kompally ,CSE School Hyderabad,ICSE Curriculum Hyderabad'
    },
    // Outdoor Learning Center
    '/outdoor-learning-center': {
        title: 'Outdoor Learning Center – Sherwood Public School',
        description: 'Experience hands-on education through Sherwood Public School\'s Outdoor Learning Center for experiential, nature-based learning.',
        keywords: 'Outdoor learning Hyderabad, Nature-based learning Secunderabad, Experiential education Kompally, Schools near Fox Sagar Lake'
    },
    // Careers
    '/careers': {
        title: 'Careers at Sherwood Public School | Teaching Jobs Hyderabad',
        description: 'Join Sherwood Public School - the leading ICSE school in Hyderabad. Explore teaching and staff opportunities at our campus near Kompally & Secunderabad.',
        keywords: 'Teaching jobs Hyderabad, School careers Secunderabad, ICSE school jobs Kompally, Schools near Jeedimetla Industrial Area'
    },
    // Gallery Page
    '/gallery': {
        title: 'Gallery – Sherwood Public School | Campus, Events & Activities',
        description: 'View photos of campus, events, student activities, celebrations, and classrooms of Sherwood Public School.',
        keywords: 'School gallery Hyderabad, Campus photos Secunderabad, Student activities Kompally, ICSE school events, Schools near Bolarum'
    },
    // ISC Programme
    '/isc': {
        title: 'ISC Programme | Sherwood Public School Hyderabad & Secunderabad',
        description: 'ISC programme at Sherwood Public School. Complete learning journey with academic excellence at the top ICSE/ISC school in Hyderabad & Secunderabad.',
        keywords: 'ISC school Hyderabad, ISC programme Secunderabad, Best ICSE ISC schools, Schools near Kompally, Schools near Alwal'
    },
    // Admissions Page
    '/admissions': {
        title: 'Admissions 2026–27 –  Nursery, LKG, UKG & ICSE | Sherwood Public School',
        description: 'Apply for Nursery, LKG & UKG admissions at Sherwood Public School Kompally. Strong ICSE academic foundation and holistic development.',
        keywords: 'Nursery Admissions Kompally, LKG Admissions 2026, UKG Admissions 2026, Pre School in Kompally, ICSE School Kompally, Admissions Open 2026–27, Pre school admissions Hyderabad, ICSE school admissions Secunderabad'
    },
    // Contact Page
    '/contact': {
        title: 'Contact Sherwood Public School – ICSE School near Kompally & Jeedimetla',
        description: 'Contact Sherwood Public School for Nursery, LKG, UKG & ICSE admissions. Located near Kompally, Suchitra, Jeedimetla & Secunderabad, Hyderabad.',
        keywords: 'Contact school Kompally, Nursery admissions Kompally, LKG admissions Hyderabad, UKG admissions Secunderabad, ICSE admissions Kompally, Schools near Fox Sagar Lake, ICSE school Petbasheerabad, Schools near Suchitra, Schools near Jeedimetla, Secunderabad contact'
    },
    // Privacy Policy
    '/privacy-policy': {
        title: 'Privacy Policy | Sherwood Public School',
        description: 'Privacy policy of Sherwood Public School - ICSE & ISC school in Hyderabad & Secunderabad.',
        keywords: 'Privacy policy, Sherwood Public School, ICSE school Hyderabad'
    },
};

// Default SEO for unknown routes
const defaultSeo = {
    title: 'Sherwood Public School – Best ICSE & ISC School in Hyderabad & Secunderabad',
    description: 'Sherwood Public School offers ICSE & ISC curriculum with academic excellence, holistic development, activities, and modern learning. Located near Kompally & Jeedimetla.',
    keywords: 'ICSE schools in Hyderabad, ICSE schools in Secunderabad, Schools near Kompally, Sherwood Public School'
};

const DynamicTitle = () => {
    const location = useLocation();

    // Normalize: strip trailing slash and lowercase so /admissions/ matches /admissions
    const normalizedPath = location.pathname.length > 1 && location.pathname.endsWith('/')
        ? location.pathname.slice(0, -1).toLowerCase()
        : location.pathname.toLowerCase();
    // Get SEO config for current route, or use default
    const seo = seoConfig[normalizedPath] || defaultSeo;


    // Fallback: Force update document.title directly
    useEffect(() => {
        document.title = seo.title;
    }, [seo.title, location.pathname]);

    // Schema.org JSON-LD for the School
    const schemaOrgJSONLD = {
        "@context": "https://schema.org",
        "@type": "School",
        "name": "Sherwood Public School",
        "url": "https://sherwoodpublicschool.edu.in",
        "logo": "https://sherwoodpublicschool.edu.in/logo192.png",
        "image": "https://sherwoodpublicschool.edu.in/logo512.png",
        "description": "Sherwood Public School is a leading ICSE and ISC school located in Kompally, Secunderabad, offering Pre-Primary (Nursery, LKG, UKG) through Grade XII education.",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Petbasheerabad, near Fox Sagar Lake, Kompally",
            "addressLocality": "Hyderabad",
            "addressRegion": "Telangana",
            "postalCode": "500014",
            "addressCountry": "IN"
        },
        "telephone": "+91-9133306121",
        "areaServed": [
            "Kompally", "Suchitra", "Jeedimetla", "Alwal", "Bolarum",
            "Secunderabad", "Medchal", "Bowenpally", "Petbasheerabad",
            "Quthbullapur", "Hyderabad"
        ],
        "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Educational Programmes",
            "itemListElement": [
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "Pre-Primary Programme (Nursery, LKG, UKG)",
                        "description": "Activity-based early childhood learning for children aged 2.5 to 5.5 years in Kompally, Secunderabad.",
                        "provider": { "@type": "School", "name": "Sherwood Public School" },
                        "educationalLevel": "Pre-Primary"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "ICSE Programme (Class 1 to X)",
                        "description": "ICSE curriculum focused on conceptual understanding, analytical thinking and holistic learning.",
                        "provider": { "@type": "School", "name": "Sherwood Public School" },
                        "educationalLevel": "Primary and Secondary"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "ISC Programme (Class XI to XII)",
                        "description": "ISC curriculum providing university-readiness with strong academic excellence.",
                        "provider": { "@type": "School", "name": "Sherwood Public School" },
                        "educationalLevel": "Higher Secondary"
                    }
                }
            ]
        },
        "sameAs": [
            "https://www.facebook.com/SherwoodPublicSchoolICSE/"
        ]
    };


    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Sherwood Public School" />
            <meta property="og:locale" content="en_IN" />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content="https://sherwoodpublicschool.edu.in/logo512.png" />
            <meta property="og:url" content={`https://sherwoodpublicschool.edu.in${location.pathname}`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content="https://sherwoodpublicschool.edu.in/logo512.png" />

            {/* Additional SEO Tags */}
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={`https://sherwoodpublicschool.edu.in${normalizedPath}`} />

            {/* Structured Data (JSON-LD) */}
            <script type="application/ld+json">
                {JSON.stringify(schemaOrgJSONLD)}
            </script>
        </Helmet>
    );
};

export default DynamicTitle;
